import { render, staticRenderFns } from "./NewsRecommendItem.vue?vue&type=template&id=9ce0d4ba&scoped=true&"
import script from "./NewsRecommendItem.vue?vue&type=script&lang=js&"
export * from "./NewsRecommendItem.vue?vue&type=script&lang=js&"
import style0 from "./NewsRecommendItem.vue?vue&type=style&index=0&id=9ce0d4ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce0d4ba",
  null
  
)

export default component.exports